import PublicDashboardOrderTable from "../../Dashboard/Components/PaymentTable";

function PublicDashboardSettingsOrders() {
  return (
    <PublicDashboardOrderTable />
  );
}

export default PublicDashboardSettingsOrders;